import { isLocalEnv } from 'app/core/utilities/env-util';

export const fileDownloader = async (url: string, filename: string) => {
  let urlFetch = url;

  // prevent CORS error
  if (isLocalEnv()) {
    urlFetch = url.replace('dev.social-ops.net', window.location.host);
  }

  await fetch(urlFetch)
    .then((response) => response.blob())
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename || urlFetch.split('/').pop() || 'download';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    })
    .catch((err) => {
      throw new Error(err);
    });
};
